import script from "./HowToPlayView.vue?vue&type=script&setup=true&lang=ts"
export * from "./HowToPlayView.vue?vue&type=script&setup=true&lang=ts"

import "./HowToPlayView.vue?vue&type=style&index=0&id=68a25b3e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68a25b3e"]])

export default __exports__